import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import useMarket from 'hook/useMarket'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toggleModalZoom } from 'store/actionReducers/ModalCommonStore'
import iconZoom from '../../../../assets/images/Home/icon-zoom.png'
import bgImage from '../../../../assets/images/Home/banner-chart-1.png'
import './PropertyTrends.scss'
import { options } from './PropertyTrendsConfig'

export default function PropertyTrends() {
  const dispatch = useDispatch();
  const [filter, setFilter] = useState({ assetType: 'overview' })
  const CommnonStore = useSelector(state => state?.CommnonStore)
  let height = 0
  if (CommnonStore?.innerWidthScreen > 1440) {
    height = 320
  } else if (CommnonStore?.innerWidthScreen > 1200) {
    height = 240
  } else if (CommnonStore?.innerWidthScreen > 700) {
    height = 650
  }
  const MarketStore = useSelector(state => state?.MarketStore)
  const { fetchWorld, filterWorld } = useMarket()

  useEffect(() => {
  }, [filter])

  const handleZoomModal = (type) => {
    dispatch(toggleModalZoom(type))
  }

  const handleFilter = (value) => {
    fetchWorld({ assetType: value })
  }

  return (
    <>

      <div className='xlwouocrlq'>
        <div className='czmxzggkie'>Xu hướng tài sản</div>
        <div className='rakssfvgkf'>
          <select onChange={(event) => handleFilter(event.target.value)} className='cemkgweerj'>
            <option value={'overview'}>Tổng quan</option>
            <option value={'stockindex'}>Chỉ số chứng khoán</option>
            <option value={'goods'}>Hàng hoá-Vật liệu</option>
          </select>
        </div>
      </div>
      <div className='ekivvsngcx'>
        <div className='sueuuerqhf'>
          <div className='yVhSqejTRQ'
            onClick={() => handleZoomModal('PropertyTrends')}>
            <img src={iconZoom} alt="" className="mFpBFtxkzO" />
          </div>
          <div className="IjbIRhYcYy">
            {
              MarketStore?.marketWorld ? <HighchartsReact
                highcharts={Highcharts}
                options={options(filterWorld(MarketStore?.marketWorld), CommnonStore)}
              /> : <div style={{ height: height }}></div>
            }
          </div>
          <img src={bgImage} className="mIuNRvzzxh" />
          <div className='vrivesgjrw'>Hồi phục</div>
          <div className='yeblquxkph'>Tăng mạnh</div>
          <div className='tthnjxhbdz'>Giảm mạnh</div>
          <div className='dzfnvtrwgf'>Suy yếu</div>
        </div>
      </div>
    </>
  )
}